import React, { createContext, useContext, useState, useCallback } from "react";
import { getPosition } from "@/lib/api";

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const [coords, setCoordsState] = useState(() => {
    try { const s = localStorage.getItem("ts_coords"); return s ? JSON.parse(s) : null; }
    catch { return null; }
  });
  const [city, setCityState] = useState(() => localStorage.getItem("ts_city") || "");
  const [status, setStatus] = useState(() => (localStorage.getItem("ts_coords") ? "granted" : "idle"));

  const setCoords = useCallback((c) => {
    setCoordsState(c);
    if (c) localStorage.setItem("ts_coords", JSON.stringify(c));
    else localStorage.removeItem("ts_coords");
  }, []);

  const requestLocation = useCallback(async () => {
    setStatus("requesting");
    try {
      const c = await getPosition();
      setCoords(c);
      setStatus("granted");
      return c;
    } catch {
      setStatus("denied");
      return null;
    }
  }, [setCoords]);

  const chooseCity = useCallback((name) => {
    setCityState(name);
    if (name) localStorage.setItem("ts_city", name); else localStorage.removeItem("ts_city");
  }, []);

  const clearLocation = useCallback(() => {
    setCoords(null);
    setStatus("idle");
  }, [setCoords]);

  return (
    <LocationContext.Provider value={{ coords, setCoords, city, chooseCity, status, requestLocation, clearLocation }}>
      {children}
    </LocationContext.Provider>
  );
}

export const useLocationCtx = () => useContext(LocationContext);
